import { render, staticRenderFns } from "./RossettoButton.vue?vue&type=template&id=5a8fa116&"
import script from "./RossettoButton.vue?vue&type=script&lang=js&"
export * from "./RossettoButton.vue?vue&type=script&lang=js&"
import style0 from "./RossettoButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports